import {buildUrlQuery} from "@Common/utils/build-url-query";
import {parseUrlQuery} from "@Common/utils/parse-url-query";

export const saveStepUrl = (step, query=undefined) => {
    window.history.replaceState(
        null, "",
        (
            location.pathname.replace(/\/scheduled-campaigns(?:\/[\w-]*)?$/, "/scheduled-campaigns/" + step) +
            buildUrlQuery({
                ...parseUrlQuery(location.search),
                label: undefined,
                ...query,
            })
        )
    );
};

